import { render, staticRenderFns } from "./SchemeDrawer.vue?vue&type=template&id=20f47403"
import script from "./SchemeDrawer.vue?vue&type=script&lang=js"
export * from "./SchemeDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports